import React from 'react';
function Add() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })));
}
export default Add;
